import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import HomeM from "../views/HomeM";
import LoginP from "../components/login/LoginP";
import MyselfP from "../views/myself/MyselfP";
import IntroduceP from "../views/myself/childComps/IntroduceP";
import LearnEnglishP from "../views/learnenglish/LearnEnglishP";
import Editor from "../views/editor/Editor";
import Mall from "../views/mall/Mall";
import MallHome from "../views/mall/view/home/MallHome";
import MallCart from "../views/mall/view/cart/MallCart";
import MallCategory from "../views/mall/view/category/MallCategory";
import MallDetail from "../views/mall/view/detail/MallDetail";
import MallProfile from "../views/mall/view/profile/MallProfile";

import IntroudeceEditorP from "../views/myself/childComps/IntroudeceEditorP";
import NoteP from "../views/note/NoteP";
import BookP from "../views/book/BookP";


import HomeMobile from "../mobile/views/home/HomeMobile";
import LoadMobile from "../mobile/views/load/LoadMobile";
import NoteMobile from "../mobile/views/note/NoteMobile";
import WordMobile from "../mobile/views/word/WordMobile";
import WordMoreMobile from "../mobile/views/word/childComps/WordMoreMobile";
import WordLoadMobile from "../mobile/views/word/childComps/WordLoadMobile";
import WordAccountMobile from "../mobile/views/word/childComps/WordAccountMobile";
import WordDetailMobile from "../mobile/views/word/childComps/WordDetailMobile";


Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    // name: 'Home',
    component: Home
  },
  // {
  //   path: '',
  //   redirect: '/Home'
  // },
  {
    path: "/Home", // pc端首页
    // name: Home,
    component: Home
  },
  {
    path: '/HomeM', // 手机端首页
    // name: HomeM,
    component: HomeM
  },
  {
    path: '/LoginP',
    // name: LoginP,
    component: LoginP
  },


  {
    path: '/MyselfP',
    // name: MyselfP,
    component: MyselfP,
    children:[
      {
        path: '/',
        // name: 'IntroduceP',
        component: IntroduceP
      },
      {
        path:'/IntroduceP',
        // name:IntroduceP,
        component:IntroduceP
      },
      {
        path:'/IntroudeceEditorP',
        // name:IntroudeceEditorP,
        component:IntroudeceEditorP
      },
    ]
  },


  {
    path: '/LearnEnglishP',
    // name: LearnEnglishP,
    component: LearnEnglishP
  },
  {
    path: '/Editor',
    // name: Editor,
    component: Editor
  },
{
    path: '/Mall',
    // name: Mall,
    component: Mall,
    children:[
      {
        path: '/',
        // name: 'MallHome',
        component: MallHome
      },
      {
        path:'/MallHome',
        // name:MallHome,
        component:MallHome
      },
      {
        path:'/MallCategory',
        // name:MallCategory,
        component:MallCategory
      },
      {
        path:'/MallCart',
        // name:MallCart,
        component:MallCart
      },
      {
        path:'/MallDetail/:iid',
        // name:MallDetail,
        component:MallDetail
      },
      {
        path:'/MallProfile',
        // name:MallProfile,
        component:MallProfile
      },

    ]
  },
  {
    path: '/NoteP',
    // name: 'NoteP',
    component: NoteP
  },
  {
    path: '/BookP',
    // name: 'BookP',
    component: BookP
  },

  {
    path: '/about',
    // name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/HomeMobile',
    component: HomeMobile
  },
    {
    path: '/LoadMobile',
    component: LoadMobile
  },
    {
    path: '/NoteMobile',
    component: NoteMobile
  },
    {
    path: '/WordMobile',
    component: WordMobile
  },
 {
    path: '/WordMoreMobile',
    component: WordMoreMobile
  },
{
    path: '/WordLoadMobile',
    component: WordLoadMobile
  },
{
    path: '/WordAccountMobile',
    component: WordAccountMobile
  },
{
    path: '/WordDetailMobile',
    component: WordDetailMobile
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
